export function checkCPF(strCPF: string) {
  strCPF = strCPF.replace(/\D/g, "");
  let sum = 0;
  let remainder = 0;

  if (strCPF === "00000000000" || strCPF.length != 11) return false;

  for (let index = 1; index <= 9; index++)
    sum = sum + parseInt(strCPF.substring(index - 1, index)) * (11 - index);
  remainder = (sum * 10) % 11;

  if (remainder == 10 || remainder == 11) remainder = 0;
  if (remainder != parseInt(strCPF.substring(9, 10))) return false;

  sum = 0;
  for (let index = 1; index <= 10; index++)
    sum = sum + parseInt(strCPF.substring(index - 1, index)) * (12 - index);
  remainder = (sum * 10) % 11;

  if (remainder == 10 || remainder == 11) remainder = 0;
  if (remainder != parseInt(strCPF.substring(10, 11))) return false;
  return true;
}

export function checkCNPJ(srtCNPJ: string) {
  srtCNPJ = srtCNPJ.replace(/\D/g, "");
  if (srtCNPJ == "") return false;

  if (srtCNPJ.length != 14) return false;

  let count = 0;
  while (count < 10) {
    if (srtCNPJ === count.toString().repeat(14)) return false;
    count++;
  }

  let size = srtCNPJ.length - 2;
  let numbers = srtCNPJ.substring(0, size);
  const digits = srtCNPJ.substring(size);
  let sum = 0;
  let pos = size - 7;

  for (let index = size; index >= 1; index--) {
    sum += Number(numbers.charAt(size - index)) * pos--;
    if (pos < 2) pos = 9;
  }

  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== Number(digits.charAt(0))) return false;

  size = size + 1;
  numbers = srtCNPJ.substring(0, size);
  sum = 0;
  pos = size - 7;

  for (let index = size; index >= 1; index--) {
    sum += Number(numbers.charAt(size - index)) * pos--;
    if (pos < 2) pos = 9;
  }
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== Number(digits.charAt(1))) return false;

  return true;
}
